import type { OverridedMixpanel } from "mixpanel-browser"

import mixpanel from "mixpanel-browser"

import { CONFIG } from "../config-global"

declare global {
    interface Window {
        mixpanel: OverridedMixpanel
    }
}

if (typeof window !== "undefined") {
    window.mixpanel = mixpanel
}

if (CONFIG.site.MIXPANEL_KEY) {
    mixpanel.init(CONFIG.site.MIXPANEL_KEY, {
        api_host: CONFIG.site.MIXPANEL_PROXY_URL,
        debug: CONFIG.site.env !== "production",
    })
}

export const analyticsCommonProperties = {}

const getUpdatedExtraData = () => {
    return analyticsCommonProperties
}

const actions = {
    identify: (id: string) => {
        mixpanel.identify(id)
    },
    register: (props: any) => {
        mixpanel.register(props)
    },

    alias: (id: string) => {
        mixpanel.alias(id)
    },

    track: (name: string, props?: any) => {
        mixpanel.track(`get_hired_ats_${name}`, { ...props, ...getUpdatedExtraData() })
    },

    getGroup: (name: string, value: any) => {
        return mixpanel.get_group(name, value)
    },
    people: {
        set: (props: any) => {
            mixpanel.people.set(props)
        },
        set_once: (props: any) => {
            mixpanel.people.set_once(props)
        },
        union: (key: string, val: any) => {
            mixpanel.people.union(key, val)
        },
    },
    reset: () => {
        return mixpanel.reset()
    },
}

const Mixpanel = actions

export default Mixpanel
